/* BF collection: shape filter pills (vanilla, no dependency).
 * Markup contract: [data-bf-root] > [data-bf-filters] buttons[data-bf-filter] + [data-bf-grid] [data-bf-card][data-shape].
 * Without JS the pills stay hidden and every pack is shown. */
(function () {
  'use strict';

  function init(root) {
    if (root.getAttribute('data-bf-ready') === 'true') return;
    var filters = root.querySelector('[data-bf-filters]');
    var grid = root.querySelector('[data-bf-grid]');
    if (!filters || !grid) return;
    root.setAttribute('data-bf-ready', 'true');

    var pills = Array.prototype.slice.call(filters.querySelectorAll('[data-bf-filter]'));
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-bf-card]'));
    var status = root.querySelector('[data-bf-status]');

    function apply(key) {
      var active = null;
      pills.forEach(function (pill) {
        var on = pill.getAttribute('data-bf-filter') === key;
        pill.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) active = pill;
      });
      cards.forEach(function (card) {
        card.hidden = !(key === 'all' || card.getAttribute('data-shape') === key);
      });
      if (status) {
        status.textContent = active ? active.textContent.replace(/\s+/g, ' ').trim() : '';
      }
    }

    filters.addEventListener('click', function (event) {
      var pill = event.target.closest('[data-bf-filter]');
      if (pill && filters.contains(pill)) apply(pill.getAttribute('data-bf-filter'));
    });

    filters.hidden = false;
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bf-root]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor: re-run when the section is re-rendered.
  document.addEventListener('shopify:section:load', boot);
})();
